export default __webpack_public_path__ + "static/media/latteseditoriNC.184939d2.svg";